import { useNavigate } from "react-router-dom";
import BottomSheet from "components/common/BottomSheet";
import loginImg from "assets/images/imgs/main/login_img.png";

const LoginBottomSheet = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    return (
        <BottomSheet
            isOpen={isOpen}
            onClose={onClose}
            title="로그인 후 이용 가능합니다."
            className="login-bottom-sheet"
        >
            <div className="login-bottom-sheet-content">
                <img src={loginImg} alt="login-img" />
                <p className="login-bottom-sheet-content-text">
                    {`로그인하면 버킷리스트 클래스에서 \n다양한 혜택을 받을 수 있어요.`}
                </p>
                <button
                    className="btn btn-purple400 btn-medium"
                    onClick={() => {
                        navigate(`/login`, { replace: true });
                    }}
                >
                    로그인
                </button>
                <p className="pass-login" onClick={onClose}>
                    그냥 둘러볼게요
                </p>
            </div>
        </BottomSheet>
    );
};

export default LoginBottomSheet;
